import { useEffect, useState } from 'react';
import deliveryService, { DeliveryConfig } from '../services/deliveryService';
import restaurantService from '../services/restaurantService';
import { guestCanOrder, PlanFeaturesPayload } from '../utils/planFeatures';

export function useGuestCanOrder(appName?: string): { canOrder: boolean; loaded: boolean } {
  const [canOrder, setCanOrder] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!appName) {
      return;
    }
    let cancelled = false;
    Promise.all([
      restaurantService.getRestaurant(appName),
      deliveryService.getConfig(appName).catch(() => null as DeliveryConfig | null),
    ])
      .then(([res, config]) => {
        if (cancelled) {
          return;
        }
        const features: PlanFeaturesPayload | undefined = res.features;
        setCanOrder(guestCanOrder(features, config));
        setLoaded(true);
      })
      .catch(() => {
        if (!cancelled) {
          setCanOrder(false);
          setLoaded(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [appName]);

  return { canOrder, loaded };
}
